import React, { useState, useEffect } from "react";

import axios from "axios";
import UserService from "rc-app/services/UserService";

import FilterSelect from "rc-app/components/Filter Select";
import SearchBar from "rc-app/components/Search Bar";
// import PropertyCardLarge from "rc-app/components/PropertyCardLarge";
import PaginationRounded from "rc-app/components/Pagination";
import Button from "rc-app/components/Button";
import { useNavigate } from "react-router-dom";

import DataTable from "rc-app/components/DataTable";
import Modal from "@mui/material/Modal";
import AddCustomerForm from "rc-app/components/AddCustomerForm";

import CustomerCard from "rc-app/components/Card/CustomerCard";
import PriceFilter from "rc-app/components/PriceFilter";
import { showErrorToast, showSuccessToast } from "rc-app/utils/toast";
import {
  createReCustomer,
  deleteCustomer,
} from "rc-app/api/customerActionsApi";
import { getAgentProfile } from "rc-app/api/agentActionsApi";
import { getAgentDefaultCurrency } from "rc-app/api/currencyActionsApi";
import Icon from "rc-app/components/Icons";
// import { toPascalCase } from "rc-app/utils";

import { CircularProgress } from "@mui/material";

export const Customers = () => {
  const [loading, setLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [allProperties, setAllProperties] = useState([]);
  const [allCustomer, setAllCustomer] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [filterCustomers, setFilterCustomers] = useState([]);
  // const [region, setRegion]= useState()
  const [agentId, setAgentId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const pageLimit = 10;

  const navigate = useNavigate();

  const [defaultCurrency, setDefaultCurrency] = useState();

  const [selectedRegionOption, setSelectedRegionOption] = useState({
    region: "all",
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAgentDefaultCurrency(
        UserService.getUseremail()
      );
      console.log("agencyLogoresponse", response);
      setDefaultCurrency(response?.symbol);
    };
    fetchData();
  }, []);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const selectName = event.target.name;
    setSelectedRegionOption((prevState) => ({
      ...prevState,
      [selectName]: selectedValue,
    }));
    if (event.target.name === "agency") {
      const selectedValue = event.target.value;
      const selectName = event.target.name;
      setSelectedOptionForTable((prevState) => ({
        ...prevState,
        [selectName]: agency[selectedValue],
      }));
    } else {
      const selectedValue = event.target.value;
      const selectName = event.target.name;
      setSelectedOptionForTable((prevState) => ({
        ...prevState,
        [selectName]: selectedValue,
      }));
    }

    console.log("name", event.target.name);
  };

  // const region: { [key: string]: string } = {
  //   Abruzzo: "abruzzo",
  //   "Aosta Valley": "aosta_valley",
  //   Puglia: "puglia",
  //   Calabria: "calabria",
  //   Campania: "campania",
  //   Lazio: "lazio",
  //   Liguria: "liguria",
  //   Marche: "marche",
  //   Sicily: "sicily",
  // };

  const clientCities = [
    "All",
    ...new Set(
      allCustomer
        .map((customer: any) => customer?.address?.province)
        .filter(Boolean)
    ),
  ];

  const region = clientCities.reduce(
    (acc: { [key: string]: string }, province) => {
      if (province === "All") return acc;
      const temp = province.charAt(0).toUpperCase() + province.slice(1);
      acc[temp] = province;
      return acc;
    },
    {}
  );

  const propertiesCity = [
    "All",
    ...new Set(
      allProperties
        .map((property: any) => property?.address?.province)
        .filter(Boolean)
    ),
  ];

  const location = propertiesCity.reduce(
    (acc: { [key: string]: string }, province) => {
      if (province === "All") return acc;
      const temp = province.charAt(0).toUpperCase() + province.slice(1);
      acc[temp] = province;
      return acc;
    },
    {}
  );

  const handleDetailButton = (customerId: string) => {
    // HIGHLIGHT: Pass current page as URL parameter when navigating to details
    navigate(`/customer_details?customerId=${customerId}`, {
      state: {
        breadcrumbs: [
          { path: "/", label: "Home" },
          { path: "/customers", label: "My Customers" },
          {
            path: `/customer_details?customerId=${customerId}`,
            label: "Customer Details",
          },
        ],
        referrer: "/customers",
      },
    });
  };

  const handleTabButton = (searchTerm: string) => {
    console.log("Search term:", searchTerm);
  };

  // const handlePageChange = (page: number) => {
  //   setCurrentPage(page);
  // };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSearchTerm("");
  };

  async function fetchCustomers() {
    try {
      setLoading(true);
      setIsSearching(true);
      let regionKey = "";
      console.log("Selected region:", selectedRegionOption.region);
      if (
        selectedRegionOption.region !== "all" &&
        region[selectedRegionOption?.region as any]
      ) {
        regionKey = region[selectedRegionOption.region as any];
      }

      const API_URL = `${
        process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL
      }/api/v1/realestate/views/re_customer/agent/customer/${UserService.getUseremail()}?sort_by=created_at&sort_order=-1&page=${
        currentPage - 1
      }&limit=${pageLimit}&province=${regionKey}`;
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });
      setCustomers(response.data.re_customer_list);

      setTotalPages(response.data.total_re_customers);

      setFilterCustomers(response.data.re_customer_list);
      setLoading(false);
      setIsSearching(false);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  }
  useEffect(() => {
    fetchCustomers();
  }, [
    // selectedRegionOption.region,
    currentPage,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const API_URL = `${
          process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL
        }/api/v1/realestate/views/re_customer/agent/customer/${UserService.getUseremail()}?sort_by=created_at&sort_order=-1&page=${
          currentPage - 1
        }&limit=${pageLimit}`;
        const response = await axios.get(API_URL, {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "ngrok-skip-browser-warning": "disabled",
            "Content-Type": "application/json",
          },
        });
        setAllCustomer(response.data.re_customer_list);
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };

    fetchData();
  }, [currentPage, pageLimit]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const API_URL = `${
          process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL
        }/api/v1/realestate/views/mp_digital_twin/agent/properties/${UserService.getUseremail()}?sort_by=created_at&sort_order=-1&page=${
          currentPage - 1
        }&limit=${pageLimit}`;

        const response = await axios.get(API_URL, {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "ngrok-skip-browser-warning": "disabled",
            "Content-Type": "application/json",
          },
        });
        setAllProperties(response.data.mp_digital_twin_list);
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };

    fetchData();
  }, [currentPage, pageLimit]);

  const handleCustomerSearch = (searchTerm: string) => {
    const cleanedSearch = searchTerm.trim().toLowerCase();
    setSearchTerm(searchTerm);

    // If search is empty after trimming → reset list
    if (cleanedSearch === "") {
      setFilterCustomers(customers);
      return;
    }

    const filtered = customers.filter(
      (item) =>
        item.first_name.toLowerCase().includes(cleanedSearch) ||
        item.last_name.toLowerCase().includes(cleanedSearch) ||
        item.email_id.toLowerCase().includes(cleanedSearch) ||
        item.client_id.toLowerCase().includes(cleanedSearch) ||
        item.address?.city.toLowerCase().includes(cleanedSearch) ||
        item.mobile_number.toString().startsWith(cleanedSearch)
    );

    setFilterCustomers(filtered);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [agency, setAgency] = useState<{ [key: string]: string }>({});
  // const [properties, setProperties] = useState([]);
  const [filterDigitalTwinRows, setFilterDigitalTwinRows] = useState([]);

  const [digitalTwin, setDigitalTwin] = useState([]);

  const [selectedOptionForTable, setSelectedOptionForTable] = useState({
    agency: "all",
    visibility: "all",
    location: "all",
    rooms: "all",
    // price: 0,
  });

  const visibility: { [key: string]: string } = {
    Exclusive: "exclusive",
    Network: "network",
  };
  const rooms: { [key: string]: number } = {
    "2 Bedrooms": 2,
    "3 Bedrooms": 3,
    "4 Bedrooms": 4,
    "5 Bedrooms": 5,
    "6 Bedrooms": 6,
  };

  // const location: { [key: string]: string } = {
  //   Abruzzo: "abruzzo",
  //   "Aosta Valley": "aosta_valley",
  //   Puglia: "puglia",
  //   Calabria: "calabria",
  //   Campania: "campania",
  //   Lazio: "lazio",
  //   Liguria: "liguria",
  //   Marche: "marche",
  //   Sicily: "sicily",
  // };

  async function fetchProperties(minPrice = 0, maxPrice = 0) {
    try {
      let agencyKey = "";
      let visibilityKey = "";
      let roomsKey = 0;
      let locationKey = "";
      // let priceMinQueryParam = "";
      // if (selectedOptionForTable.price > 0) {
      //   priceMinQueryParam = `&price=${selectedOptionForTable.price}`;
      // }

      if (
        selectedOptionForTable.agency !== "all" &&
        selectedOptionForTable.agency
      ) {
        agencyKey = selectedOptionForTable.agency;
      }

      console.log(
        "agencyKey",
        agencyKey,
        agency[selectedOptionForTable.agency]
      );

      if (
        selectedOptionForTable.visibility !== "all" &&
        visibility[selectedOptionForTable.visibility]
      ) {
        visibilityKey = visibility[selectedOptionForTable.visibility];
      }

      if (
        selectedOptionForTable.rooms !== "all" &&
        rooms[selectedOptionForTable.rooms]
      ) {
        roomsKey = rooms[selectedOptionForTable.rooms];
      }

      if (
        selectedOptionForTable.location !== "all" &&
        selectedOptionForTable.location
      ) {
        locationKey = selectedOptionForTable.location;
      }

      console.log("locationKey", locationKey, roomsKey, agencyKey);

      const API_URL = `${
        process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL
      }/api/v1/realestate/views/mp_digital_twin/agent/properties/${UserService.getUseremail()}?sort_by=created_at&sort_order=-1&page=0&limit=100${
        agencyKey == "all" || "All" || undefined
          ? `&agency_id=all`
          : `&agency_id=${agencyKey}`
      }${
        locationKey == "all" || "All" ? "" : `&province=${locationKey}`
      }&property_visibility=${
        visibilityKey === "network" || visibilityKey === "exclusive"
          ? visibilityKey
          : "all"
      }&num_bedrooms=${roomsKey === 0 ? "all" : roomsKey}&${
        minPrice != 0 ? `min_price=${minPrice}` : ""
      }&${maxPrice != 0 ? `max_price=${maxPrice}` : ""}`;
      // &property_visibility=${visibilityKey}&province=${locationKey}&num_bedrooms=${roomsKey}
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });
      // setProperties(response.data.mp_digital_twin_list);
      console.log(response.data.mp_digital_twin_list, "kmkmkm");
      const digitalTwinRows = response.data.mp_digital_twin_list.map(
        (item: any) => {
          return {
            id: item._id,
            property_id: item.property_id,
            title: item.title,
            visibility: item.property_visibility,
            location: item.address.province,
            // area: item.characteristics.area_sqm,
            area:
              item.characteristics.area?.value != null
                ? item.characteristics.area?.value +
                  " " +
                  item.characteristics.area?.unit
                : 0,
            rooms: item.characteristics.num_bedrooms,
            price: `${item?.pricing?.currency["symbol"]} ${item.pricing.price}`,
            commision: `${item?.pricing?.currency["symbol"]} ${item.pricing.condominium_expenses}`,
            mp_digital_twin_id: item._id,
            seller_agency_id: item.agency?._id,
            buyer_agent_id: agentId,
            added_by:
              UserService.findRole("agent")[0] == "agent"
                ? "agent"
                : "customer",
          };
        }
      );
      setDigitalTwin(digitalTwinRows);
      // setTotalPages(response.data.total_mp_digital_twin);
      setFilterDigitalTwinRows(digitalTwinRows);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  }

  useEffect(() => {
    getAgentProfile(UserService.getUseremail()).then((data: any) => {
      setAgentId(data.agent._id);
      fetchProperties();
    });
  }, [
    selectedOptionForTable.agency,
    selectedOptionForTable.visibility,
    selectedOptionForTable.location,
    selectedOptionForTable.rooms,
    // selectedOptionForTable.price,
  ]);

  useEffect(() => {
    async function fetchAgency() {
      try {
        const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency?sort_by=created_at&sort_order=-1`;
        const response = await axios.get(API_URL, {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "ngrok-skip-browser-warning": "disabled",
            "Content-Type": "application/json",
          },
        });
        const convertedObject: { [key: string]: string } = {};
        response.data.re_agency_list.forEach((item: any) => {
          convertedObject[item.name] = item._id;
        });
        setAgency(convertedObject);
        console.log("agency", convertedObject);
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    }

    fetchAgency();
  }, []);

  // const handlePriceChange = (newValue: number) => {
  //   setSelectedOptionForTable((prevState) => ({
  //     ...prevState,
  //     ["price"]: newValue,
  //   }));
  //   console.log("Slider value:", newValue);
  // };
  const handleFilterChange = (minPrice: string, maxPrice: string) => {
    const minPriceValue = minPrice ? parseInt(minPrice) : 0;
    const maxPriceValue = maxPrice ? parseInt(maxPrice) : 0;
    if (parseInt(minPrice) > parseInt(maxPrice)) {
      alert("Min price should not be greater than max price.");
      return;
    } else if (parseInt(maxPrice) < parseInt(minPrice)) {
      alert("Max price should not be less than min price.");
      return;
    } else {
      fetchProperties(minPriceValue, maxPriceValue);
    }
  };

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    mobile_number: "",
    city: "",
    province: "",
    country: "",
  });

  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    mobile_number: "",
    city: "",
    province: "",
    country: "",
  });

  const validateField = (name: string, value: string): string => {
    switch (name) {
      case "first_name":
        if (!value.trim()) return "First name is required";
        if (!/^[a-zA-Z ]+$/.test(value)) return "Only letters allowed";
        return "";
      case "last_name":
        if (!value.trim()) return "Last name is required";
        if (!/^[a-zA-Z ]+$/.test(value)) return "Only letters allowed";
        return "";
      case "email_id":
        if (!value.trim()) return "Email is required";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          return "Invalid email format";
        return "";
      case "mobile_number":
        if (!value.trim()) return "Mobile number is required";
        if (!/^[0-9]{10,15}$/.test(value))
          return "Invalid phone number (10-15 digits)";
        return "";
      case "city":
        if (!value.trim()) return "City is required";
        return "";
      case "province":
        if (!value.trim()) return "Province is required";
        return "";
      case "country":
        if (!value.trim()) return "Country is required";
        return "";
      default:
        return "";
    }
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log("target", name);

    // Validate the field as user types
    const error = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  console.log("eexx", formData);

  const [selectionModel, setSelectionModel] = React.useState([]);

  const jsonFormData = {
    first_name: formData.first_name,
    last_name: formData.last_name,
    email_id: formData.email_id,
    mobile_number: formData.mobile_number,
    address: {
      address_line1: "",
      address_line2: "",
      landmark: "",
      postal_code: "",
      city: formData.city,
      province: formData.province,
      country: formData.country,
    },
    property_shortlist: selectionModel,
    agent_id: [agentId],
  };
  console.log("jsonFormData", jsonFormData);

  const [agentDetails, setAgentDetails] = useState();
  const [isCustomerCreatedSuccess, setIsCustomerCreatedSuccess] =
    useState(false);
  const [isCustomerCreatedFailed, setIsCustomerCreatedFailed] = useState(true);

  useEffect(() => {
    getAgentProfile(UserService.getUseremail).then((res: any) => {
      setAgentDetails(res.agent);
    });
  }, []);
  console.log("kkkkk", agentDetails);

  const handleSelectionChange = (newSelection: any) => {
    setSelectionModel(
      newSelection.map((item: any, index: any) => {
        console.log("rows", filterDigitalTwinRows[index]);
        return {
          mp_digital_twin_id: filterDigitalTwinRows[index].mp_digital_twin_id,
          seller_agency_id: filterDigitalTwinRows[index].seller_agency_id,
          buyer_agent_id: filterDigitalTwinRows[index].buyer_agent_id,
          added_by: filterDigitalTwinRows[index].added_by,
        };
      })
    );
  };

  console.log("selectionModel ", selectionModel);

  const handleCreateCustomer = (e: React.FormEvent) => {
    e.preventDefault();

    // Final validation before submission
    const newErrors = {
      first_name: validateField("first_name", formData.first_name),
      last_name: validateField("last_name", formData.last_name),
      email_id: validateField("email_id", formData.email_id),
      mobile_number: validateField("mobile_number", formData.mobile_number),
      city: validateField("city", formData.city),
      province: validateField("province", formData.province),
      country: validateField("country", formData.country),
    };

    setErrors(newErrors);

    // Check if form is valid
    const isValid = Object.values(newErrors).every((error) => !error);
    if (isValid) {
      console.log("Form submitted:", formData);

      createReCustomer(jsonFormData)
        .then((res: any) => {
          console.log("jsonres", res);
          showSuccessToast("Customer Created Successfully..!");
          setIsCustomerCreatedSuccess(res.success);
          setIsCustomerCreatedFailed(res.success);
          setTimeout(() => {
            setIsCustomerCreatedSuccess(false);
            setIsCustomerCreatedFailed(true);
            setTimeout(() => {
              fetchCustomers();
              handleClose();
            }, 2000);
          }, 3000);
        })
        .catch((err) => {
          showErrorToast(err.message);
   
        });
    }
  };

  // digitalTwin search
  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
    console.log("searchTerm", searchTerm);
    const searchTermLowerCase = searchTerm.toLowerCase();
    const filtered = digitalTwin.filter(
      (item) =>
        item.title.toLowerCase().includes(searchTermLowerCase) ||
        // || item.matterport_id.toString().includes(searchTermLowerCase)
        (item.rooms && item.rooms.toString().includes(searchTermLowerCase))
    );
    setFilterDigitalTwinRows(filtered);
  };

  console.log("filterCustomers", filterCustomers);

  const handleAddCustomer = () => {
    navigate(`/add_customer`, {
      state: {
        breadcrumbs: [
          { path: "/", label: "Home" },
          { path: "/customers", label: "My Customers" },
          {
            path: "/add_customer",
            label: "Add Customer",
          },
        ],
        referrer: "/customers",
      },
    });
  };

  return (
    <>
      <div className="flex-grow ">
        {/* <Breadcrumbs /> */}
        <div className="flex flex-start gap-2 px-2 max-md:flex-col">
          <div className="flex flex-1 max-md:order-2">
            <SearchBar
              onSearch={handleCustomerSearch}
              placeholder="Search..."
              value={searchTerm}
              // onClick={handleCustomerSearch}
              // onKeyDown={handleFilterByKey}
            />
          </div>
          <div className="flex max-md:order-1 bg-[#2E4051] items-center justify-center rounded-md max-md:w-full w-64 shadow-md cursor-pointer">
            <Button
              children={`Add a New Customer`}
              className="flex w-full bg-[#008564] rounded-md items-center justify-center text-[12px] sm:text-[11px] md:text-[15px] lg:text-[17px] xl:text-[18px] md:px-4 h-[40px]"
              onClick={handleAddCustomer}
            />
          </div>

          {/* <div
            className="bg-[#2E4051] flex items-center justify-center rounded-md w-32 shadow-md cursor-pointer"
            onClick={() => setFilterOpen((pre) => !pre)}
          >
            <Button
              children="Filter"
              className="bg-[#2E4051]  rounded-md px-2 h-[40px] text-[0.938rem] "
              onClick={() => console.log("click")}
            />
            {filterCount > 0 && (
              <span className="bg-[#008564] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                {filterCount}
              </span>
            )}
          </div> */}
        </div>

        {/* {filterOpen && (
          <div className="w-full flex px-2 mt-2">
            <div className="w-full flex flex-col flex-start md:items-center gap-1 py-4 shadow-md bg-white dark:bg-[#161F28] rounded-md ">
              <div className="flex relative w-full px-2">
                <span className="flex text-white font-medium text-xl">
                  Filter
                </span>
                <Icon
                  name="ic-close"
                  className="absolute top-1 right-3 w-4 h-4 cursor-pointer"
                  onClick={() => setFilterOpen((pre) => !pre)}
                />
              </div>
              <div className="flex w-full h-[1px] bg-[#2E4051]" />
              <div className="flex flex-col lg:flex-row w-full pt-2 lg:items-center">
                <div className="w-full flex lg:flex-1 flex-wrap flex-col sm:flex-row md:flex-row justify-center">
                  <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-2 mx-auto">
                    <FilterSelect
                      name="type"
                      label="Type"
                      options={["All", ...Object.keys(type)]}
                      value={selectedOption.type}
                      className="bg-[#2E4051] text-white"
                      handleChange={handleSelectChange}
                    />
                  </div>

                  <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-2 mx-auto">
                    <FilterSelect
                      name="lifestyle"
                      label="Lifestyle"
                      options={["All", ...Object.keys(lifestyle)]}
                      value={selectedOption.lifestyle}
                      className="bg-[#2E4051] text-white"
                      handleChange={handleSelectChange}
                    />
                  </div>

                  <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-2 mx-auto">
                    <FilterSelect
                      name="contract_type"
                      label="Contract Type"
                      options={["All", ...Object.keys(contract_type)]}
                      value={selectedOption.contract_type}
                      className="bg-[#2E4051] text-white"
                      handleChange={handleSelectChange}
                    />
                  </div>
                </div>
                <div className="flex flex-row w-full lg:w-52 xl:w-56 gap-4 justify-end px-2 lg:mt-5">
                  <div className="flex  ">
                    <Button
                      children={`Clear All`}
                      className="bg-[#2E4051] rounded-md text-[12px] sm:text-[11px] md:text-[15px] lg:text-[17px] xl:text-[18px] px-4 h-[40px]"
                      onClick={handleClearFilters}
                    />
                  </div>
                  <div className="flex ">
                    <Button
                      children={`Apply`}
                      className="bg-[#008564] rounded-md text-[12px] sm:text-[11px] md:text-[15px] lg:text-[17px] xl:text-[18px] px-4 h-[40px]"
                      onClick={() => {
                        handleFilter();
                        setFilterOpen((pre) => !pre);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}

        {loading ? (
          <div className="flex min-h-screen justify-center items-center h-64">
            <CircularProgress />
          </div>
        ) : filterCustomers.length > 0 ? (
          <div className="grid gap-3 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-3 px-2">
            {filterCustomers.map((customer: any) => (
              <div
                key={customer._id}
                className="grid grid-cols-1 gap-4 rounded-2xl bg-white dark:bg-[#0C1117] border-[#374B5E] cursor-pointer hover:shadow-[0_45px_75px_-18px_rgba(0,0,0,0.5)] hover:-translate-y-1 transition-all duration-400"
                onClick={() => handleDetailButton(customer._id)}
              >
                {/* <div className="flex-grow"> */}
                <div className="flex w-full bg-[#1F3A4A] text-white rounded-2xl px-1 lg:px-2 py-4 shadow-lg items-center gap-2 lg:gap-2">
                  <div className="flex w-[35%] items-center justify-center">
                    {/* Profile Image */}
                    {customer?.profile_pic ? (
                      // <img
                      //   src={customer?.profile_pic}
                      //   alt="Profile"
                      //   className="w-28 h-28 md:w-32 md:h-32 rounded-full object-cover border-4 border-[#889DB2] shadow-md"
                      // />
                      <div className="w-28 h-28 md:w-32 md:h-32  rounded-full overflow-hidden border-4 border-[#889DB2] shadow-md">
                        <img
                          src={customer?.profile_pic}
                          alt="Profile"
                          className="w-full h-full object-fill"
                        />
                      </div>
                    ) : (
                      <div className="w-28 h-28 md:w-32 md:h-32 rounded-full flex items-center justify-center bg-[#2E4051] text-[#889DB2] text-3xl md:text-4xl font-bold border-4 border-[#889DB2] shadow-md">
                        {`${customer?.first_name?.[0]?.toUpperCase()}${customer?.last_name?.[0]?.toUpperCase()}` ||
                          ""}
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col w-[65%] gap-4">
                    {/* Name */}
                    <h2 className="text-xl font-semibold">{`${customer?.first_name} ${customer?.last_name}`}</h2>

                    {/* Role */}
                    <div className="flex w-full items-center gap-2">
                      <Icon name="ic-properties" className="w-5 h-5 " />
                      <span className="text-black  dark:text-white text-sm flex items-center ">
                        {`${customer?.property_shortlist.length} Properties`}
                      </span>
                    </div>

                    {/* Email */}
                    <div className="flex w-full items-center gap-2">
                      <Icon name="ic-mail" className="w-5 h-5 " />
                      <span className="text-black  dark:text-white text-sm flex items-center ">
                        {customer?.email_id}
                      </span>
                    </div>

                    {/* Phone  */}
                    <div className="flex w-full items-center gap-2">
                      <Icon name="ic-call" className="w-5 h-5 " />
                      <span className="text-black  dark:text-white text-sm flex items-center ">
                        {customer?.mobile_number}
                      </span>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            ))}
          </div>
        ) : searchTerm ? (
          // ||
          // selectedOption.type !== "All" ||
          // selectedOption.lifestyle !== "All" ||
          // selectedOption.contract_type !== "All"
          <div className="text-center py-10 text-[#F4F5F7] dark:text-white">
            No properties match your current filters
            {searchTerm && (
              // ||
              // selectedOption.type !== "All" ||
              // selectedOption.lifestyle !== "All" ||
              // selectedOption.contract_type !== "All"
              <div className="mt-2 text-sm opacity-75">
                Try adjusting your search or filters
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-10 text-[#F4F5F7] dark:text-white">
            No properties found
          </div>
        )}

        {totalPages > 0 && !isSearching && filterCustomers.length > 0 && (
          <div className="m-5">
            {!loading && (
              <PaginationRounded
                currentPage={currentPage}
                totalPages={Math.ceil(totalPages / pageLimit)}
                limit={pageLimit}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        )}
      </div>

      <div className=" hidden flex-col w-full h-screen overflow-y-auto">
        <div className="flex-grow pt-[5rem] pb-[6rem] md:pt-[5rem] lg:pt-[6rem] px-2 lg:px-3 gap-2 justify-center">
          <div className="flex flex-row items-center gap-2 w-full pb-2">
            <div className="flex items-center w-1/2 text-[18px] sm:text-[22px] md:text-[28px] lg:text-[32px] xl:text-[36px] gap-2">
              <span className="font-extrabold text-[#1B0039]">
                My Customers
              </span>
              <span className="font-extrabold text-[#283BBE]">
                {filterCustomers.length}
              </span>
            </div>
            <div className="flex w-1/2 justify-end">
              <Button
                children={`+ Add customer`}
                className="bg-[#FF307A] rounded-md text-[12px] sm:text-[11px] md:text-[15px] lg:text-[17px] xl:text-[18px] px-4 h-[40px]"
                onClick={handleOpen}
              />
            </div>
          </div>
          <div className="w-full  flex flex-start gap-5 px-2 py-3 sm:p-3 md:p-5 shadow-md bg-white rounded-md">
            <div className="w-full lg:w-[70%] xl:w-[60%] flex flex-start flex-col md:flex-row  gap-2">
              <div className="w-full sm:w-full md:w-[40%] lg:w-1/3 px-2 sm:px-4 ">
                <FilterSelect
                  name="region"
                  label="Region"
                  options={["All", ...Object.keys(region)]}
                  value={selectedRegionOption["region"]}
                  className="bg-white text-black"
                  handleChange={handleSelectChange}
                />
              </div>
              <div className="w-full sm:w-full md:w-[60%] lg:w-2/3 px-2 sm:px-4 mt-auto">
                <SearchBar
                  onSearch={handleCustomerSearch}
                  placeholder="Serach by Name, Id, city"
                  value="Serach by Name, Id, city"
                />
              </div>
            </div>
          </div>

          {filterCustomers.length > 0 &&
            filterCustomers.map((filterCustomer) => (
              <div
                key={filterCustomer.client_id}
                className="w-full mt-3 flex flex-col items-center md:gap-5 p-2 md:p-2 shadow-md bg-white rounded-md"
              >
                <CustomerCard
                  isProperty={false}
                  title={
                    filterCustomer.first_name + " " + filterCustomer.last_name
                  }
                  isCustomer={true}
                  customerId={
                    filterCustomer.client_id ? filterCustomer.client_id : ""
                  }
                  customer_id={filterCustomer._id}
                  handleDetailButton={handleDetailButton}
                  handleTabButton={handleTabButton}
                  property_shortlisted={
                    filterCustomer.property_shortlist.length
                  }
                  data={[
                    {
                      value:
                        filterCustomer.email_id !== null
                          ? filterCustomer.email_id
                          : "Not Available",
                      icon: "Email",
                    },
                    {
                      value:
                        filterCustomer.mobile_number !== null
                          ? filterCustomer.mobile_number
                          : "Not Available",
                      icon: "Phone Number",
                    },
                    {
                      value:
                        filterCustomer.address &&
                        filterCustomer.address.city !== null
                          ? filterCustomer.address.city
                          : "Not Available",
                      icon: "City",
                    },
                    {
                      value:
                        filterCustomer.address &&
                        filterCustomer.address.province !== null
                          ? filterCustomer.address.province
                          : "Not Available",
                      icon: "Region",
                    },
                    {
                      value:
                        filterCustomer.address &&
                        filterCustomer.address.country !== null
                          ? filterCustomer.address.country
                          : "Not Available",
                      icon: "Country",
                    },
                    { value: "MM/DD/YYYY", icon: "Customer Last Login" },
                    {
                      value:
                        filterCustomer.address &&
                        filterCustomer.address.joined_date !== null
                          ? filterCustomer.address.joined_date
                          : "Not Available",
                      icon: "Customer Joined Date",
                    },
                  ]}
                  detailButton={
                    <Button
                      children="Customer Details"
                      className="bg-[#283BBE] max-sm:w-full rounded-md text-[12px] sm:text-[11px] md:text-[15px] lg:text-[17px] xl:text-[18px] px-4 h-[40px] "
                      onClick={() => {
                        handleDetailButton(filterCustomer._id);
                      }}
                    />
                  }
                  removeButton={
                    <Button
                      children={`Remove`}
                      textColor="black"
                      className="text-[#EC0000] font-semibold border-2 border-[#EC0000] rounded-md text-[10px] sm:text-[10px] md:text-[12px] lg:text-[15px] xl:text-[15px] px-4 h-[45px] sm:h-[40px] "
                      onClick={() => {
                        deleteCustomer(filterCustomer._id).then((res: any) => {
                          console.log("remove from shortlist", res);
                        });
                      }}
                    />
                  }
                />
              </div>
            ))}

          {filterCustomers.length === 0 && <div>No customers found</div>}

          {/* <div className="m-5">
            <PaginationRounded
              currentPage={currentPage}
              totalPages={totalPages}
              limit={pageLimit}
              onPageChange={handlePageChange}
            />
          </div> */}
        </div>

        <div className="flex top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div className="fixed top-[10%] left-[15%] w-[70%] h-[80%] overflow-auto justify-center bg-white border-2 border-black shadow-md p-4 ">
                <div className={`flex `}>
                  <h1 className="font-bold text-[#FF307A] text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] xl:text-[22px] mr-5">
                    Customer Details
                  </h1>
                </div>

                <div className="flex flex-row items-center gap-2 w-full py-4 ">
                  <div className="flex w-full justify-end">
                    <AddCustomerForm
                      formData={formData}
                      onInputChange={handleInputChange}
                      errors={errors}
                    />
                  </div>
                </div>

                <div className={`flex `}>
                  <h1 className="font-bold text-[#FF307A] text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] xl:text-[22px] mr-5">
                    Customer property shortlist
                  </h1>
                </div>

                <div className="w-full flex flex-col flex-start md:items-center gap-1 p-4 shadow-md bg-white rounded-md mb-3 ">
                  <div className="w-full xl:w-full ">
                    <div className="w-full flex flex-wrap flex-col sm:flex-row md:flex-row justify-center">
                      <div className="w-full sm:w-1/2 md:w-1/4  px-2 mb-2 mx-auto">
                        <FilterSelect
                          name="agency"
                          label="Agency"
                          options={["All", ...Object.keys(agency)]}
                          value={selectedOptionForTable["agency"]}
                          className="bg-white text-black"
                          handleChange={handleSelectChange}
                        />
                      </div>

                      <div className="w-full sm:w-1/2 md:w-1/4 px-2 mb-2 mx-auto">
                        <FilterSelect
                          name="visibility"
                          label="Visibility"
                          options={["All", ...Object.keys(visibility)]}
                          value={selectedOptionForTable.visibility}
                          className="bg-white text-black"
                          handleChange={handleSelectChange}
                        />
                      </div>

                      <div className="w-full sm:w-1/2 md:w-1/4 px-2 mb-2 mx-auto">
                        <FilterSelect
                          name="location"
                          label="Location"
                          options={["All", ...Object.keys(location)]}
                          value={selectedOptionForTable["location"]}
                          className="bg-white text-black"
                          handleChange={handleSelectChange}
                        />
                      </div>

                      <div className="w-full sm:w-1/2 md:w-1/4 px-2 mb-2 mx-auto">
                        <FilterSelect
                          name="rooms"
                          label="Rooms"
                          options={["All", ...Object.keys(rooms)]}
                          value={selectedOptionForTable["rooms"]}
                          className="bg-white text-black"
                          handleChange={handleSelectChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="w-full md:w-full lg:w-full xl:w-full max-sm:gap-2 flex flex-wrap flex-col sm:flex-row md:flex-row md:items-center sm:flex-start md:justify-between px-1 md:px-2">
                    <div className="flex w-full flex-wrap sm:w-[100%] md:w-[50%] lg:w-[50%] xl:w-1/2 sm:pl-2 md:pl-0 justify-center">
                      <PriceFilter
                        defaultCurrency={defaultCurrency}
                        onFilterChange={handleFilterChange}
                      />
                    </div>

                    <div className="flex flex-grow  sm:w-[100%] md:w-[100%] lg:w-[40%] xl:w-1/2 sm:pl-2">
                      <SearchBar
                        placeholder="Search by Name"
                        onSearch={handleSearch}
                        value="test"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex mt-4">
                  <DataTable
                    rows={filterDigitalTwinRows}
                    handleSelectionChange={handleSelectionChange}
                  />
                </div>

                <div className=" mt-4 flex items-center justify-center flex-col  sm:flex-row gap-3 w-full  ">
                  <div
                    className="flex w-1/3 cursor-pointer text-white items-center justify-center  bg-[#283BBE] rounded-md text-[10px] sm:text-[10px] md:text-[12px] lg:text-[15px] xl:text-[15px] px-4 h-[45px] sm:h-[40px] "
                    onClick={handleCreateCustomer}
                  >
                    {`Save & Send via Email `}
                    {` Save `}
                  </div>

                  <div
                    className="flex w-1/3 cursor-pointer items-center justify-center text-black  border border-[#20B038] bg-[#20B038] rounded-md text-[10px] sm:text-[10px] md:text-[12px] lg:text-[15px] xl:text-[15px] px-4 h-[45px] sm:h-[40px]  "
                    onClick={() => {
                      // handleCreateCustomer()
                      console.log("clikced");
                    }}
                  >
                    Save & Send via Whatsapp
                  </div>

                  {isCustomerCreatedSuccess && (
                    <div className="w-1/3 flex items-center justify-center flex-col  sm:flex-row gap-3 ">
                      <div className="flex cursor-pointer text-white items-center justify-center border border-[##008C27]  bg-[#31B957] rounded-full text-[10px] sm:text-[10px] md:text-[12px] lg:text-[15px] xl:text-[15px] px-4 h-[45px] sm:h-[40px] ">
                        {`Customer created successfully `}
                      </div>
                    </div>
                  )}
                  {!isCustomerCreatedFailed && (
                    <div className="w-1/3 flex items-center justify-center flex-col  sm:flex-row gap-3   ">
                      <div className="flex cursor-pointer text-white items-center justify-center border border-[#6D0000]  bg-[#EC0000] rounded-full text-[10px] sm:text-[10px] md:text-[12px] lg:text-[15px] xl:text-[15px] px-4 h-[45px] sm:h-[40px] ">
                        {`Failed... , Please Retry! `}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};
